// extracted by mini-css-extract-plugin
export default {"imageWrapper":"YD-z","hovered":"ZD-z","hoverImage":"_D-z","mainImage":"aE-z","imageNoBackground":"bE-z","fullSizeImage":"cE-z"};